import { Popover, Box, PopoverOrigin } from '@mui/material';
import { ReactNode, useState } from 'react';

interface PopoverOnClickProps {
  element: ReactNode;
  children: ReactNode;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

const PopoverOnClick = ({
  element,
  children,
  anchorOrigin,
  transformOrigin,
}: PopoverOnClickProps) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(anchorEl ? null : event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? 'popover-on-click' : undefined;

  return (
    <Box sx={{ width: 70, pt: 1, borderRadius: 3 }}>
      <Box sx={{ cursor: 'pointer' }} onClick={handleClick}>
        {element}
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin || {
            vertical: 'bottom',
            horizontal: 'center',
          }
        }
        transformOrigin={
          transformOrigin || {
            vertical: 'top',
            horizontal: 'center',
          }
        }
      >
        {children}
      </Popover>
    </Box>
  );
};

export default PopoverOnClick;
